/* ============================================================
   AXION MOTION — full motion layer.
   reveal-on-scroll · staggered grids · hero word-clip ·
   scroll parallax · magnetic buttons · page-transition crossfade.

   Safety: the only CSS that hides content is gated on
   <html class="ax-motion"> (added first thing here), so if this
   script never runs nothing is hidden. prefers-reduced-motion is
   honoured everywhere. Page fade-in only fires AFTER an internal
   navigation (sessionStorage flag), so first paint / LCP is never
   delayed.
   ============================================================ */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.add('ax-motion');
  var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var fine = mq('(pointer: fine)');
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
  function nextFrame(fn) { raf(function () { raf(fn); }); }

  /* ---------- page fade-in (only when arriving via an internal nav) ---------- */
  if (!reduce && sessionStorage.getItem('ax_nav')) {
    sessionStorage.removeItem('ax_nav');
    root.classList.add('ax-fade');
    nextFrame(function () { root.classList.add('ax-fade-in'); });
    setTimeout(function () { root.classList.add('ax-fade-in'); }, 500); /* fail-safe */
  }

  /* ---------- hero headline reveal ---------- */
  /* Owned by Layer 3 PARSE (axion-parse.js): the headline compiles
     from monospace tokens. The old word-clip lived here. */

  /* ---------- reveal-on-scroll + staggered groups ---------- */
  function tag(el, i) { el.setAttribute('data-ax-reveal', ''); if (i) el.style.transitionDelay = (Math.min(i, 8) * 55) + 'ms'; }
  ['.ax-hero__overline', '.ax-hero__sub', '.ax-hero__ctas', '.ax-pgrid__head', '.ax-cgrid__title',
   '.ax-reviews__head', '.ax-about__media', '.ax-about__text', '.ax-news__inner']
    .forEach(function (sel) { document.querySelectorAll(sel).forEach(function (el) { tag(el, 0); }); });
  ['.ax-hero__overline', '.ax-hero__sub', '.ax-hero__ctas'].forEach(function (sel, i) {
    var el = document.querySelector(sel); if (el) el.style.transitionDelay = (90 + i * 90) + 'ms';
  });
  var groups = {
    '.ax-trust__inner': '.ax-trust__item', '.ax-pgrid__grid': '.ax-card',
    '.ax-stats__grid': '.ax-stat', '.ax-cgrid__grid': '.ax-ccard', '.ax-reviews__scroll': '.ax-review'
  };
  Object.keys(groups).forEach(function (p) {
    document.querySelectorAll(p).forEach(function (parent) {
      parent.querySelectorAll(groups[p]).forEach(function (kid, i) { tag(kid, i); });
    });
  });

  if (!reduce) {
    var els = document.querySelectorAll('[data-ax-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('ax-in'); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      els.forEach(function (e) { io.observe(e); });
    } else { els.forEach(function (e) { e.classList.add('ax-in'); }); }
    setTimeout(function () {
      var vh = window.innerHeight;
      document.querySelectorAll('[data-ax-reveal]:not(.ax-in)').forEach(function (el) {
        var r = el.getBoundingClientRect(); if (r.top < vh && r.bottom > 0) el.classList.add('ax-in');
      });
    }, 1700);
  }

  /* ---------- scroll parallax (desktop, motion-on only) ---------- */
  if (!reduce && fine) {
    var px = [];
    function addPx(sel, speed) { document.querySelectorAll(sel).forEach(function (el) { px.push({ el: el, s: speed }); el.style.willChange = 'transform'; }); }
    addPx('.ax-hero__media img', 0.06);
    addPx('.ax-about__media img', 0.09);
    addPx('.ax-ccard__media img', 0.05);
    var ticking = false;
    function onPx() {
      var vh = window.innerHeight;
      px.forEach(function (o) {
        var r = o.el.getBoundingClientRect();
        if (r.bottom < -40 || r.top > vh + 40) return;
        var off = ((r.top + r.height / 2) - vh / 2) * o.s;
        o.el.style.transform = 'translate3d(0,' + (-off).toFixed(1) + 'px,0) scale(1.08)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; raf(onPx); } }, { passive: true });
    onPx();
  }

  /* ---------- magnetic buttons (desktop) ---------- */
  if (!reduce && fine) {
    document.querySelectorAll('.ax-hero__ctas .btn-primary, .ax-hero__ctas .btn-outline, .product-form .btn-primary, .cta-row .btn-ghost')
      .forEach(function (btn) {
        btn.style.transition = 'transform .3s cubic-bezier(0.16,1,0.3,1), background .25s, color .25s, border-color .25s';
        btn.addEventListener('mousemove', function (e) {
          var r = btn.getBoundingClientRect();
          var dx = e.clientX - (r.left + r.width / 2);
          var dy = e.clientY - (r.top + r.height / 2);
          btn.style.transform = 'translate(' + (dx * 0.18).toFixed(1) + 'px,' + (dy * 0.30).toFixed(1) + 'px)';
        });
        btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
      });
  }

  /* ---------- page-transition crossfade (internal links, desktop only) ---------- */
  if (!reduce && fine) {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || a.hasAttribute('download')) return;
      if (a.target && a.target !== '_self') return;
      var url; try { url = new URL(a.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin) return;                       /* external / mailto / tel */
      if (url.pathname === location.pathname && url.search === location.search) return; /* same page */
      if (/^\/(cart|checkout|account)/.test(url.pathname)) return;       /* never delay the buy path */
      e.preventDefault();
      sessionStorage.setItem('ax_nav', '1');
      root.classList.add('ax-leaving');
      setTimeout(function () { location.href = a.href; }, 160);
    }, true);
    /* bfcache return: undo the leaving state */
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) { root.classList.remove('ax-leaving'); }
    });
  }
})();
